<template>
  <div class="slide-toggle-row">
      <div :class="{
          'qrw-heading-xs': true,
          'v1-grey-10-color': true
        }">
          <slot></slot>
      </div>
      <BaseToggleSwitcher fillBg="v1-grey-10" fillCircle="v1-grey-10" @input="v => $emit('input', v)" :value="value"/>
  </div>
</template>

<script>
import SlideToggle from "@/components/SlideToggle.vue"

export default {
    components: {
        SlideToggle
    },
    props: {
        value: [String, Number, Boolean]
    }
}
</script>

<style>
.slide-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
</style>